import React from 'react';
import { Header } from './components/Header';
import { Leaderboard } from './components/Leaderboard';
export function App() {
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Leaderboard data-id="element-3" />
      </main>
    </div>;
}